<template>
  <base-view title="Habilitar webhook">
    <b-row align-content="center" align-v="center">
      <b-col cols="4" align-self="start">
        <select-items
          v-model="fields.webhook"
          :items="items"
          label="name"
          placeholder="Selecione um webhook"
          no-options="Nenhum webhook encontrado, você pode já ter selecionado todos os webhooks disponíveis"
          :reduce-function="(item) => item.id"
          :disabled="!!fields.id"
          @update:value="
            () => {
              getWebhookDetails(fields.webhook);
              errorMessages['webhook'] = [];
            }
          "
        />
        <b-form-invalid-feedback :state="isFieldValid('webhook')">
          <span v-for="(error, index) in errorMessages['webhook']" :key="index">
            {{ error }}
          </span>
        </b-form-invalid-feedback>
      </b-col>
      <b-col cols="4" align-self="start">
        <b-input
          placeholder="URL de comunicação"
          v-model="fields.url"
          type="url"
          @input="errorMessages['url'] = []"
        >
        </b-input>
        <b-form-invalid-feedback :state="isFieldValid('url')">
          <span v-for="(error, index) in errorMessages['url']" :key="index">
            {{ error }}
          </span>
        </b-form-invalid-feedback>
      </b-col>
      <b-col align-self="start">
        <b-form-checkbox v-model="fields.active" switch>
          {{ fields.active ? 'Habilitado' : 'Desabilitado' }}
        </b-form-checkbox>
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
        align-self="center"
        class="text-center my-5"
      >
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
      <b-col
        cols="12"
        class="mt-4"
        v-if="webhookDetails.description || webhookDetails.documentation"
      >
        <span class="fs-14 c-gray-3 mb-5" v-if="webhookDetails.description">{{
          webhookDetails.description
        }}</span>
        <hr />
        <div
          v-if="webhookDetails.documentation"
          v-html="webhookDetails.documentation"
        ></div>
      </b-col>
      <b-col cols="12" class="my-4">
        <b-button variant="success" @click="save" :disabled="loading">
          <i class="fas fa-save mr-2"></i>
          Salvar
        </b-button>
      </b-col>
    </b-row>
  </base-view>
</template>

<script>
import { mapState } from 'vuex';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import makeToast from '@/mixins/makeToast';

export default {
  name: 'SaveWebhook',
  mixins: [makeToast],
  data() {
    return {
      loading: false,
      fields: {
        id: '',
        webhook: '',
        active: true,
        url: '',
      },
      webhookDetails: {},
      items: [],
      errorMessages: {},
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    descriptionToShow() {
      const webhook = this.items.find(
        (item) => item.id === this.fields.webhook
      );

      return (webhook || {}).description;
    },
  },
  mounted() {
    const { id } = this.$route.params;
    this.getWebhooksNotEnableds(id);
    this.getWebhookEnabled(id);
  },
  methods: {
    getWebhookEnabled(id) {
      if (!id) return;

      this.loading = true;

      shopkeeperAppApi
        .get(`/webhook/enabled?id=${id}&construpUserId=${this.dadosUsuario.id}`)
        .then((response) => {
          const { data } = response.data || {};
          this.fields = data || {};
          this.fields.webhook = data.webhook.id;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getWebhooksNotEnableds(id) {
      this.loading = true;

      /**
       * Buscamos somente os webhooks que não estão habilitados quando vamos realizar uma criação,
       * numa edição buscamos somente os que já foram habilitados
       */
      shopkeeperAppApi
        .get(
          `/webhook/enabled/combo?construpUserId=${
            this.dadosUsuario.id
          }&onlyNotEnabled=${!id}`
        )
        .then((response) => {
          this.items = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getWebhookDetails(webhook) {
      if (!webhook) {
        this.webhookDetails = {};
        return;
      }

      this.loading = true;

      shopkeeperAppApi
        .get(`/webhook/${webhook}/details`)
        .then((response) => {
          this.webhookDetails = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      this.loading = true;
      this.$store.dispatch('startLoader');

      shopkeeperAppApi
        .post(`/webhook/enabled`, {
          ...this.fields,
          construpUserId: this.dadosUsuario.id,
        })
        .then((response) => {
          this.fields.id = response.data.data.id;
          this.makeToast('Sucesso', 'Webhook habilitado com sucesso');
        })
        .catch((error) => {
          this.makeToast(
            'Houve um erro ao cadastrar o webhook',
            error.response.data.message || 'Verifique os campos e tente novamente',
            'danger'
          );
          this.errorMessages = error.response.data || {};
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    isFieldValid(key) {
      return !this.errorMessages[key] || this.errorMessages[key].length === 0;
    },
  },
};
</script>

<style scoped>
>>> pre {
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  line-height: 1.5;
  overflow-x: auto;
}

>>> code {
  font-family: 'Courier New', monospace;
  color: #333;
}
</style>